<template>
  <v-container fliud>
      <v-dialog v-model="dialog" style="overflow: hidden;">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            darky
            v-bind="attrs"
            v-on="on"
            ><v-icon>mdi-tune</v-icon>Settings</v-btn>
        </template>
            <v-card>
            <v-row class="d-flex justify-space-around align-start">
                <v-col md="auto">
                    <v-card-title primate-title class="justify-center">
                        Name
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                            label="Name"
                            v-model="username"
                            @input="changeUsername()"/>
                    </v-card-text>
                    <v-divider v-if="category.Preorder" horizontal></v-divider>
                    <v-card-title v-if="category.Preorder" primary-title class="justify-center">
                        Pre-Order
                    </v-card-title>
                    <v-card-text v-if="category.Preorder">
                            <preorder 
                                :reset="settingsReset">
                            </preorder>
                    </v-card-text>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col md="auto">
                    <v-card-title primary-title class="justify-center">
                        Biz Dev
                    </v-card-title>
                    <v-card-text>
                        <biz-dev-input 
                            @bizDevSettings="bizDevSettingsChange"
                            :refresh="dialog"
                            :year="year"
                            :category="category">
                        </biz-dev-input>
                    </v-card-text>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col md="auto">
                    <v-card-title primary-title class="justify-center">
                        Other
                    </v-card-title>
                    <v-card-text>
                            <otherSettings></otherSettings>
                    </v-card-text>
                </v-col>
            </v-row>
            </v-card>
        </v-dialog>
  </v-container>
</template>

<script>

import otherSettings from '@/components/Home/otherSettings.vue'
import BizDevInput from '@/components/Home/bizDevInput.vue'
import preorder from '@/components/Home/preorder.vue'

export default {
    name:'Settings',
    beforeMount() {
        this.username = localStorage.username
    },
    components: {
        otherSettings,
        BizDevInput,
        preorder
    },
    props: {
        settingsReset: {type: Number},
        doors: {type: Object},
        category: {type: Object},
        year: {type: Number},
    },
    data() {
        return {
            dialog: false,
            username: localStorage.username,
        }
    },
    methods: {
        bizDevSettingsChange() {
            this.$emit('bizDevSettings', 'refresh')
        },
        changeUsername() {
            localStorage.username = this.username
        }
    },
}
</script>

<style>

</style>